export default __webpack_public_path__ + "static/media/IMG-20190829-WA0033 2.10c901ea.jpg";